import { DataService } from './../../../shared/services/data/data.service';
import { PlaningService } from './../../../shared/services/planing/planing.service';
import { ChangeDetectorRef, Component, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, UntypedFormBuilder, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { DatatableBaseComponent } from 'app/shared/components/datatable-base.component';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SessionService } from 'app/shared/services/session/session.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import * as moment from 'moment';
import { Clipboard } from '@angular/cdk/clipboard';
import { FilterPopUpTable } from 'app/shared/models/class/filterPopupTable/filterPopUpTable';
import { FilterpredicateService } from 'app/shared/services/filterPredicate/filterpredicate.service';
import { MatCheckboxDefaultOptions, MAT_CHECKBOX_DEFAULT_OPTIONS } from '@angular/material/checkbox';

@Component({
  selector: 'app-admin-modifications',
  templateUrl: './admin-modifications.component.html',
  styleUrls: ['./admin-modifications.component.scss'],
  // providers: [
  //   {
  //     provide: NG_VALUE_ACCESSOR,
  //     useExisting: forwardRef(() => AdminModificationsComponent),
  //     multi: true,
  //   },
  //   { provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: { clickAction: 'noop' } as MatCheckboxDefaultOptions },
  // ],
})
export class AdminModificationsComponent extends DatatableBaseComponent implements OnInit  {
  clubCode: any;
  title: string;

  searchForm: UntypedFormGroup;

  valueInput: string;

  modifications: any[] = [];
  filteredModifications: any[] = [];
  dataSource = new MatTableDataSource<any>();

  displayedColumns = ['date', 'offerName', 'oldSession', 'newSession', 'trainee', 'customerFirstName', 'customerEmail', 'customerPhoneNumber', 'plannerUserName', 'isCustomerNotified', 'notifierUserName'];

  isLoading = false;

  userConnected: InfosUser;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';

  valueFilter: FilterPopUpTable[];

  checkboxNotify = null;

  tape = [null, true, false];

  constructor(
    protected uiSrv: UiService,
    private formBuilder: UntypedFormBuilder,
    private faIconService: FaiconService,
    private authService: AuthService,
    private tooltipSrv: TooltipService,
    private route: ActivatedRoute,
    private planingsSrv: PlaningService,
    private clipboard: Clipboard,
    private filterPredicate: FilterpredicateService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
  ) {
    super(uiSrv);
  }

  ngOnInit(): void {
    this.userConnected = this.authService.getDecodedToken();

    this.initComponent();
  }

  private async initComponent() {
    this.userConnected = this.authService.getDecodedToken();
    this.clubCode = await this.route.snapshot.queryParams.clubCode && this.userConnected.role === 'admin' ?
      this.route.snapshot.queryParams.clubCode : this.userConnected.club_code;

    const title = {
      admin: `Liste des modifications de sessions du club : ${this.clubCode}`,
      club: `Liste des modifications de sessions de mon club`
    };

    this.title = title[this.userConnected.role];

    this.isLoading = true;
    this.initSubscriptions();
    this.initForm();


  }

  initForm(): void{
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

  private initSubscriptions(): void {
    this.addSubscription(
      this.planingsSrv.getSessionsTraineeHistory(this.clubCode).subscribe((modificationsFromSrv => {
        this.modifications = modificationsFromSrv;
        this.filteredModifications = [...this.modifications];
        this.filterByNotify();
      }))
    );

    this.addSubscription(
      this.dataService.valueFilterPopUpSelected$.subscribe({
        next: valueFilter => {
          this.valueFilter = valueFilter;
          this.getModificationsByclubWithFilter(valueFilter);
          this.cdr.detectChanges();
        }
      })
    )

  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.filteredModifications);
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'oldSession': return item.oldSession.dateLib;
        case 'newSession': return item.newSession.dateLib;
        default: return item[property];
      }
    };

    this.dataSource.filterPredicate = (data, filter: string) => {
      const accumulator = (currentTerm, key) => {
        switch (key) {
          case 'oldSession': return currentTerm + data.oldSession.dateLib;
          case 'newSession': return currentTerm + data.newSession.dateLib;
          default: return currentTerm + data[key];
        }
      };
      const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
      // Transform the filter by converting it to lowercase and removing whitespace.
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };

    this.dataSource.paginator = this.paginator;
    this.length = this.filteredModifications.length;
    this.isLoading = false;
  }

  private getModificationsByclubWithFilter(valueFilter: FilterPopUpTable[]): void {

    this.dataSource.filter = JSON.stringify(valueFilter)?.trim().toLowerCase();
    if (this.valueFilter?.length < 2) {
      this.filterPredicate.dataFilteredTable$.next(this.dataSource.filteredData);
    }
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getTooltip(value: string): string {
    return this.tooltipSrv.getTooltip(value);
  }

  getTooltipSession(object): string {
    let tooltip = "";

    if (object.sessionStartDate && object.sessionEndDate) {
      tooltip += "Date de début " + moment(object.sessionStartDate).utc().format('DD/MM/YYYY HH:mm');
      tooltip += "\n Date de fin " + moment(object.sessionEndDate).utc().format('DD/MM/YYYY HH:mm');
    } else if (object.sessionStartDate) {
      tooltip += "Date de début " + moment(object.sessionStartDate).utc().format('DD/MM/YYYY HH:mm');
    } else if (object.sessionEndDate) {
      tooltip += "Date de fin " + moment(object.sessionEndDate).utc().format('DD/MM/YYYY HH:mm');
    }

    return tooltip;
  }

  copyTooltip(object): void {
    let tooltip = "";

    if (object.sessionStartDate && object.sessionEndDate) {
      tooltip += "Date de début " + moment(object.sessionStartDate).utc().format('DD/MM/YYYY HH:mm');
      tooltip += "\n Date de fin " + moment(object.sessionEndDate).utc().format('DD/MM/YYYY HH:mm');
    } else if (object.sessionStartDate) {
      tooltip += "Date de début " + moment(object.sessionStartDate).utc().format('DD/MM/YYYY HH:mm');
    } else if (object.sessionEndDate) {
      tooltip += "Date de fin " + moment(object.sessionEndDate).utc().format('DD/MM/YYYY HH:mm');
    }

    this.clipboard.copy(tooltip);
  }

  notifyClient(event, session) {
    let bodyToNotify = {
      userKey: this.authService.getDecodedToken().sub,
      historyKey: session.historyKey,
      isNotified: event.checked
    }

    this.planingsSrv.notifyClient(bodyToNotify).subscribe(() => {
      this.uiSrv.showSnackbar('Modification de confirmation prise en compte');

      session.isCustomerNotified = event.checked;
      this.filterByNotify();
    })
  }

  writeValue(value: any) {
    this.checkboxNotify = value || this.tape[0];
  }

  nextNotify(event) {
    event.preventDefault();
    this.checkboxNotify = this.tape[(this.tape.indexOf(this.checkboxNotify) + 1) % this.tape.length];
    this.filterByNotify();
  }

  filterByNotify() {
    if (this.checkboxNotify === null) {
      this.filteredModifications = [...this.modifications].filter(m => !m.isCustomerNotified);

    } else {
      if (this.checkboxNotify) {
        this.filteredModifications = [...this.modifications].filter(m => m.isCustomerNotified);
      } else {
        this.filteredModifications = [...this.modifications];
      }
    }

    this.initTable();
  }


  applyFilter(filterValue: string): void {
    this.valueInput = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }
}
